import { useState } from 'react';
import { ClerksService } from '../../../../services/clerks-service';
import { useLocation, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

export type AdminManageClerkHeaderState = {
	toggleDeleteModal: () => void;
	showDeleteModal: boolean;
	deleteClerk: (clerkId: string) => void;
}

export default function useAdminManageClerkHeader(): AdminManageClerkHeaderState {
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const location = useLocation();
	const navigate = useNavigate();
	const toggleDeleteModal = () => {
		setShowDeleteModal(!showDeleteModal);
	}

	const deleteClerk = async (clerkId: string) => {
		const res = await ClerksService.deleteClerk(clerkId);
		if (res) {
			toast.success("Clerk successfully deleted");
			if (location.pathname.includes(`/clerks/${clerkId}`)) {
				navigate("..")
			}
		}
	}

	return {
		toggleDeleteModal,
		showDeleteModal,
		deleteClerk,
	}
}
